import { OnChanges } from "@angular/core";
import { ColumnMode } from "@swimlane/ngx-datatable";
import { Component, Input, OnInit, SimpleChanges } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { TranslateService } from "@ngx-translate/core";
import { ApiService } from "src/app/services/api.service";
import { SelectedOrderTradeComponent } from "../selected-order-trade/selected-order-trade.component";
import { GridsterService } from "src/app/services/gridster.service";
import { CdkDragDrop, moveItemInArray } from "@angular/cdk/drag-drop";
import { Subject } from "rxjs";
@Component({
  selector: "app-order-history",
  templateUrl: "./order-history.component.html",
  styleUrls: ["./order-history.component.scss"],
})
export class OrderHistoryComponent implements OnInit {
  rows = [];

  dtTrigger: Subject<any> = new Subject<any>();
  ColumnMode = ColumnMode;

  dtOptions: {
    // scrollX: true,
    paging: boolean;
    searching: boolean;
    autoWidth: boolean;
    info: boolean;
    responsive: boolean;
    fixedHeader: boolean;
    select: boolean;
    order: any[];
    sorting: any[];
  };

  @Input() orderRequest: any;
  @Input() typesList: any;
  @Input() symbolList: any;
  DataToShow: boolean = false;
  getTransaction(value) {
    if (value != null) {
      if (this.translate.currentLang == "en") {
        return this.typesList.find((x) => x.TransactionId == value)
          .TransactionNameE;
      } else {
        return this.typesList.find((x) => x.TransactionId == value)
          .TransactionTypeA;
      }
    }
  }
  getSymbols(value) {
    if (value != null) {
      if (this.translate.currentLang == "en") {
        return this.symbolList.find((x) => x.SymbolCode == value).SymbolNameE;
      } else {
        return this.symbolList.find((x) => x.SymbolCode == value).SymbolNameA;
      }
    }
  }
  isDate(prop) {
    return prop == "TransactionDate";
  }
  isSymbol(prop) {
    return prop == "SymbolShortNameEn";
  }
  isNum(prop) {
    return (
      prop == "TransactionPrice" &&
      prop == "OrderValue" &&
      prop == "TransactionQty"
    );
  }
  isCustdName(prop) {
    return prop == "CustodianNameEn";
  }

  constructor(
    public translate: TranslateService,
    public snackBar: MatSnackBar,
    private _gridService: GridsterService,
    public dialog: MatDialog
  ) {}

  ngOnInit(): void {
    if (this._gridService.getTradeHistoryColumns()) {
      this.columns = this._gridService.getTradeHistoryColumns();
    } else {
      this.columns = this.allFilters;
    }
    this.dtTrigger.next();
    this.WindowResize();

    this.dtOptions = {
      // scrollX: true,
      paging: false,
      searching: false,
      autoWidth: true,
      info: false,
      responsive: true,
      fixedHeader: true,
      select: false,
      order: [[0, "desc"]],
      sorting: [],
      // ajax: (dataTablesParameters: any, callback) => {
      //   this.fetchEGX("EGX30").subscribe((res) => {
      //     this.isCompaniesLoading = false;
      //     this.companies = res as CompanyList[];
      //     this.WindowResize();

      //     callback({
      //       recordsTotal: this.companies.length,
      //       data: [],
      //     });
      //   });
      // },
    };
  }
  allFilters = [
    { prop: "TransactionDate", name: "date", isChecked: true },
    { prop: "TicketNo", name: "#transaction", isChecked: true },
    { prop: "OrderNumber", name: "#order", isChecked: true },
    { prop: "InvoiceId", name: "#invoice", isChecked: true },
    { prop: "TransactionTypeID", name: "type", isChecked: true },
    { prop: "SymbolShortNameEn", name: "symbolCode", isChecked: true },
    { prop: "CustodianCode", name: "custodianCode", isChecked: true },
    { prop: "CustodianNameEn", name: "custodian-name", isChecked: false },
    { prop: "TransactionQty", name: "qty", isChecked: true },
    { prop: "TransactionPrice", name: "price", isChecked: true },
    { prop: "OrderValue", name: "value", isChecked: true },
  ];
  statusValue = [
    {
      value: 1,
      viewValue:
        this.translate.currentLang == "en" ? "LocalNew" : "جديد داخليا",
    },
    {
      value: 2,
      viewValue:
        this.translate.currentLang == "en" ? "LocalUpdate" : "تعديل داخلي",
    },
    {
      value: 3,
      viewValue:
        this.translate.currentLang == "en" ? "LocalCancel" : "إلغاء داخلي",
    },
    {
      value: 4,
      viewValue: this.translate.currentLang == "en" ? "Divided" : "مقسم",
    },
    {
      value: 5,
      viewValue:
        this.translate.currentLang == "en"
          ? "FIXAwaitNew"
          : "انتظار إرسال البورصة",
    },
    {
      value: 6,
      viewValue: this.translate.currentLang == "en" ? "FIXNew" : "تم الإرسال",
    },
    {
      value: 7,
      viewValue:
        this.translate.currentLang == "en"
          ? "FIXAwaitUpdate"
          : "انتظار إرسال التعديل",
    },
    {
      value: 8,
      viewValue:
        this.translate.currentLang == "en" ? "FIXUpdate" : "تم التعديل",
    },
    {
      value: 9,
      viewValue:
        this.translate.currentLang == "en"
          ? "FIXAwaitCancel"
          : "انتظار إرسال الإلغاء",
    },
    {
      value: 10,
      viewValue: this.translate.currentLang == "en" ? "FIXCancel" : "ملغى",
    },
    {
      value: 11,
      viewValue:
        this.translate.currentLang == "en"
          ? "FIXAwaitSuspend"
          : "انتظار إرسال الإيقاف",
    },
    {
      value: 12,
      viewValue: this.translate.currentLang == "en" ? "FIXSuspend" : "موقوف",
    },
    {
      value: 13,
      viewValue:
        this.translate.currentLang == "en"
          ? "UpdateDividedNoCascade"
          : "تعدبل تقسيم بدون توزيع",
    },
    {
      value: 14,
      viewValue:
        this.translate.currentLang == "en"
          ? "UpdateDividedCascade"
          : "تعديل تقسيم بالتوزيع",
    },
    {
      value: 15,
      viewValue: this.translate.currentLang == "en" ? "Automatic" : "تلقائي",
    },
    {
      value: 16,
      viewValue:
        this.translate.currentLang == "en" ? "FixPrivate" : "FixPrivate",
    },
    {
      value: 17,
      viewValue: this.translate.currentLang == "en" ? "FixPublic" : "FixPublic",
    },
    {
      value: 18,
      viewValue:
        this.translate.currentLang == "en"
          ? "FIXAwaitApprove"
          : "إنتظار الإعتماد للإرسال",
    },
    {
      value: 20,
      viewValue: this.translate.currentLang == "en" ? "HubNew" : "HubNew",
    },
    {
      value: 21,
      viewValue: this.translate.currentLang == "en" ? "HubUpdate" : "HubUpdate",
    },
    {
      value: 22,
      viewValue: this.translate.currentLang == "en" ? "HubCancel" : "HubCancel",
    },
    {
      value: 23,
      viewValue:
        this.translate.currentLang == "en" ? "HubRejected" : "HubRejected",
    },
    {
      value: 24,
      viewValue: this.translate.currentLang == "en" ? "FixRejected" : "رفض",
    },
    {
      value: 25,
      viewValue:
        this.translate.currentLang == "en" ? "FixRupdate" : "FixRupdate",
    },
    {
      value: 26,
      viewValue:
        this.translate.currentLang == "en" ? "FixExpired" : "FixExpired",
    },
    {
      value: 27,
      viewValue:
        this.translate.currentLang == "en" ? "DisApproved" : "رفض ائتمان",
    },
  ];
  columns = [];

  drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.columns, event.previousIndex, event.currentIndex);
    this.updateCols();
  }
  updateCols() {
    this._gridService.saveTradeHistoryColumns(this.columns);
    this.WindowResize();
  }
  WindowResize() {
    setTimeout(() => {
      window.dispatchEvent(new Event("resize"));
    }, 250);
  }

  toggle(col, event) {
    col.isChecked = !col.isChecked;
    this.WindowResize();
    this.updateCols();
  }
  get colsss() {
    return this.columns.filter((col) => col.isChecked);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.orderRequest != null && changes.orderRequest != null) {
      if (
        changes.orderRequest.currentValue != changes.orderRequest.previousValue
      ) {
        this.DataToShow = true;
        this.orderRequest = changes.orderRequest.currentValue;
      } else {
        this.DataToShow = false;
      }
    } else {
      this.DataToShow = false;
    }
  }

  getStatus(value) {
    return this.statusValue.find((x) => x.value == value).viewValue;
  }

  viewOrder(row) {
    const dialogRef = this.dialog.open(SelectedOrderTradeComponent, {
      panelClass: "custom-dialog-container",
      data: { order: row },
      width: "400px",
    });
    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        this.snackBar
          .open("Order Updated Successfully", "Ok", {
            duration: 2000,
          })
          .afterDismissed()
          .subscribe((res) => {});
      } else {
        this.snackBar.open("Order Update Failed", "Close", {
          duration: 2000,
        });
      }
    });
  }
}
